/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Shipping_Settings_TitleInputs */

const en_user_shipping_settings_title = /** @type {(inputs: User_Shipping_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Shipping Settings`)
};

const es_user_shipping_settings_title = /** @type {(inputs: User_Shipping_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuracion de envio por usuario`)
};

/**
* | output |
* | --- |
* | "User Shipping Settings" |
*
* @param {User_Shipping_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const user_shipping_settings_title = /** @type {((inputs?: User_Shipping_Settings_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Shipping_Settings_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_shipping_settings_title(inputs)
	return es_user_shipping_settings_title(inputs)
});